<template>
  <div class="user-avatar">
    <Resource
      :src="data.logo_url"
      :transform-resource="transformImage"
      class="w-full h-full rounded-full"
      alt="logo"
    />
    <a-popover v-if="isAdmin && showIcon">
      <template #content>{{ $t('guan-li-yuan') }}</template>
      <div class="admin">
        <iconpark-icon
          name="icon-user-admin"
          class="text-white text-[10px]"
        ></iconpark-icon>
      </div>
    </a-popover>
  </div>
</template>

<script lang="ts" setup>
import { USER_ADMIN } from '~/constants'
import { USER_LEVEL_KEY } from '~/api/interface'

const props = withDefaults(
  defineProps<{
    url?: string
    showIcon?: boolean
    data: {
      logo_url: string
      permission: number
      rights_type: string
    }
  }>(),
  {
    showIcon: true,
  }
)

const isAdmin = computed(
  () =>
    Number(props.data?.permission) !== USER_ADMIN.NORMAL &&
    ![
      USER_LEVEL_KEY.TASTE,
      USER_LEVEL_KEY.PERSONAL,
      USER_LEVEL_KEY.PERSONAL_LITE,
    ].includes(Number(props.data.rights_type))
)
</script>

<style lang="scss" scoped>
.user-avatar {
  @apply rounded-full mr-[10px]  relative;
  border: 1px solid var(--back-3);
  .admin {
    @apply absolute flex-y-center justify-center right-[-1px] -bottom-[1px] w-[16px] h-[16px] rounded-full bg-warning-6;
    box-shadow: 0px 1px 3px 0px var(--text-1-20);
  }
}
</style>
